import type React from 'react'
import { Link } from '@mui/material'

const URL_REGEX = /(https?:\/\/[^\s]+)|(www\.[^\s]+)/g
const TRAILING_PUNCTUATION_REGEX = /[.,;:!?)\]'"]+$/

// Detects bare URLs in plain-text answers and renders them as clickable links.
export function linkifyText (text: string): React.ReactNode {
  if (text == null || text === '') return text

  const parts: React.ReactNode[] = []
  let lastIndex = 0
  let match: RegExpExecArray | null
  let key = 0

  while ((match = URL_REGEX.exec(text)) !== null) {
    const rawUrl = match[0]
    const trimmedUrl = rawUrl.replace(TRAILING_PUNCTUATION_REGEX, '')
    const trailing = rawUrl.slice(trimmedUrl.length)

    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index))
    }

    const href = trimmedUrl.startsWith('www.') ? `https://${trimmedUrl}` : trimmedUrl
    parts.push(
      <Link key={key++} href={href} target='_blank' rel='noopener noreferrer'>{trimmedUrl}</Link>
    )
    if (trailing !== '') parts.push(trailing)

    lastIndex = match.index + rawUrl.length
  }

  if (lastIndex === 0) return text
  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex))
  }

  return <>{parts}</>
}
